import $ from 'jquery';

export default function nav() {
    const $el = $("header"); // change selector
    const CLASS = "is-scrolled";
    const THRESHOLD = 10;

    if (!$el.length) return;

    function update() {
        const y = window.scrollY || $(window).scrollTop();
        $el.toggleClass(CLASS, y > THRESHOLD);
    }

    update();

    // update on scroll
    $(window).on("scroll", update);
}